<p-tabView class="height100p full-height">
    <p-tabPanel header="Diagramme">
        <div class="height100p flex-row-split">
            <p-panel class="flex-item-fixed width300 height100p full-height" header="Optionen">
                <app-plot-definition #plotDefComponent [fields]="plotFields" [plot]="plotDefinition" [templates]="plotTemplates" (onStoreTemplate)="storePlotTemplate($event)"></app-plot-definition>
                <p-button class="mt-3" icon="fas fa-chart-pie" label="Generieren" (onClick)="generatePlot()"></p-button>
                <sm-form [form]="form"></sm-form>
            </p-panel>
            <div class="flex-item-fill height100p">
                <app-plot #plot class="height100p mt-3"></app-plot>
            </div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Gantt">
        <div class="height100p flex-col">
            <sm-toolbar>
                <button pButton icon="fas fa-chart-pie" label="Generieren" (click)="generateGantt()"></button>
                <p-checkbox label="Projekte zeigen" class="option" name="showProjects" [(ngModel)]="showProjects" [binary]="true" (ngModelChange)="updateGantt()"></p-checkbox>
                <p-checkbox label="Meilensteine zeigen" class="option" name="showMilestones" [(ngModel)]="showMilestones" [binary]="true" (ngModelChange)="updateGantt()"></p-checkbox>
            </sm-toolbar>
            <full-calendar #fc class="width100p flex-item-fill" [options]="calendarOptions"></full-calendar>
        </div>
    </p-tabPanel>
</p-tabView>
